import React from "react";
import { useNavigate } from "react-router-dom";

function AboutUs() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  const handleImageError = (e) => {
    console.error("Image failed to load:", e.target.src);
    e.target.src = "https://via.placeholder.com/600x400?text=Profile+Image"; // Fallback image
  };

  return (
    <div id="about" className="flex flex-col md:flex-row min-h-screen bg-[#0a1629]">
      {/* Left side with image */}
      <div className="w-full md:w-1/2 p-4 sm:p-6 lg:p-8 flex items-center justify-center">
        <div className="group relative overflow-hidden rounded-xl border-4 border-blue-500/40 shadow-xl transition-transform duration-500 hover:scale-105 hover:shadow-[0_0_40px_rgba(59,130,246,0.6)] backdrop-blur-md bg-white/5">
          <img
            src="https://res.cloudinary.com/dplxhnyrz/image/upload/v1761147443/Untitled_design_1_pjmvzz.jpg"
            alt="Ali Hassan's Portfolio"
            onError={handleImageError}
            className="w-full h-auto transition-transform duration-700 ease-in-out group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </div>

      {/* Right side with text */}
      <div className="w-full md:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 
                      animate-slide-in-right">
          About Ali Hassan
        </h1>

        <p className="text-gray-300 text-lg md:text-xl lg:text-2xl mb-4 leading-relaxed 
                     animate-fade-in-up">
          I specialize in building AI Agents, Chatbots, and production-ready SaaS MVPs
          using modern web technologies. From frontend experience to backend architecture and AI
          workflows, I focus on creating solutions that are fast, reliable, and built for real users.
        </p>

        <p className="text-gray-400 text-base md:text-lg lg:text-xl mb-8 leading-relaxed 
                     animate-fade-in-up animation-delay-200">
          My goal is simple: build smart products that solve real problems and scale with growth.
        </p>

        <button
          onClick={handleContactClick}
          className="relative w-fit px-8 py-3 text-lg font-semibold text-blue-300 
                    bg-transparent border-2 border-blue-400 rounded-lg 
                    hover:bg-blue-500/20 hover:text-blue-200 hover:border-blue-300 
                    transition-all duration-300 
                    shadow-[0_0_15px_rgba(59,130,246,0.5)] 
                    hover:shadow-[0_0_25px_rgba(59,130,246,0.8)]
                    animate-fade-in-up animation-delay-400
                    overflow-hidden"
        >
          <span className="relative z-10">Contact Me</span>
          <span className="absolute inset-0 bg-gradient-to-r from-blue-500/0 via-blue-500/30 to-blue-500/0 
                         opacity-0 hover:opacity-100 transition-opacity duration-300"></span>
        </button>
      </div>
    </div>
  );
}

export default AboutUs;